export default __webpack_public_path__ + "static/media/mobile-check.ff53f983.svg";